import { queryOptions } from '@tanstack/react-query';
import type { PolicyContent, UnacceptedPolicies } from '@/types/policy';
import * as policiesApi from '../endpoints/policies';
import type { ActivePoliciesResponseWire } from '../schemas/policy';

export const POLICY_QUERY_KEYS = {
  all: ['policies'] as const,
  active: () => [...POLICY_QUERY_KEYS.all, 'active'] as const,
  unaccepted: () => [...POLICY_QUERY_KEYS.all, 'unaccepted'] as const,
  version: (policyId: string, versionId: string) =>
    [...POLICY_QUERY_KEYS.all, 'version', policyId, versionId] as const,
  content: (policyId: string, versionId: string) =>
    [...POLICY_QUERY_KEYS.all, 'content', policyId, versionId] as const,
  userAcceptances: () => [...POLICY_QUERY_KEYS.all, 'user-acceptances'] as const,
} as const;

export const activePoliciesQueryOptions = () =>
  queryOptions({
    queryKey: POLICY_QUERY_KEYS.active(),
    queryFn: async (): Promise<ActivePoliciesResponseWire> => {
      return policiesApi.getActivePolicies();
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 15,
  });

export const unacceptedPoliciesQueryOptions = () =>
  queryOptions({
    queryKey: POLICY_QUERY_KEYS.unaccepted(),
    queryFn: async (): Promise<UnacceptedPolicies> => {
      return policiesApi.getUnacceptedPolicies();
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 15,
    meta: { persist: false },
  });

export const policyContentQueryOptions = (policyId: string, versionId: string) =>
  queryOptions({
    queryKey: POLICY_QUERY_KEYS.content(policyId, versionId),
    queryFn: async (): Promise<PolicyContent> => {
      return policiesApi.getPolicyContent(policyId, versionId);
    },
    enabled: !!policyId && !!versionId,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60,
  });
